const separation = 10;
export default class LineBackdrop {
  backdrop;
  linesQuantity;
  size;
  constructor(backdrop) {
    this.backdrop = backdrop;
    this.size = this.backdrop.clientWidth >= this.backdrop.clientHeight ? this.backdrop.clientWidth : this.backdrop.clientHeight;
    this.linesQuantity = Math.ceil(this.size / separation);
    this.renderLines();
  }

  renderLines() {
    let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '100%');
    svg.setAttribute('height', '100%');
    for(let i = 1; i <= this.linesQuantity * 2; i++) {
      let line = document.createElementNS('http://www.w3.org/2000/svg','line');
      line.setAttribute('x1', 0);
      line.setAttribute('y1', (this.size - (i * separation)));
      line.setAttribute('x2', i * separation);
      line.setAttribute('y2', this.size);
      line.setAttribute('stroke', '#C4C4C4');
      line.setAttribute('stroke-width', '1');
      svg.append(line);
    }
    this.backdrop.append(svg);
  }
}


// WEBPACK FOOTER //
// ./ui/assets/js/LineBackdrop/LineBackdrop.js